import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { imgURL } from '../../pages/Home';

const FestivalNotice = ({ el }: any) => {
  const [notice, setNotice] = useState(false);
  return (
    <>
      <div className="notice_title">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setNotice((prev: any) => !prev);
          }}
        >
          유의사항{' '}
          {notice ? (
            <img src={`${imgURL}/btn_event_minus.png`} alt="" />
          ) : (
            <img src={`${imgURL}/btn_event_plus.png`} alt="" />
          )}
        </a>
      </div>
      {notice && <img src={isMobile ? el.mobileImageUrl : el.pcImageUrl} alt="" />}
    </>
  );
}

export default FestivalNotice;